<template>
  <StandardLayout header="Reservierungen">
    <template v-slot:main>
      <div class="list-group">
        <router-link :to="{name: 'reservationDetail', params: {id: r.number}}" v-slot="{navigate, href}"
                     v-for="r in reservations"
                     :key="r.number">
          <div class="list-group-item" @click="navigate">
            <div>
              {{ r.startDateStr }} {{ r.startHour }}:00
            </div>
            <div>
              {{ r.product.name }}
            </div>
            <div>
              <div class="badge"
                   :class="getBadgeClass(r.state)">
                {{ r.state }}
              </div>
            </div>
          </div>
        </router-link>
      </div>
    </template>
  </StandardLayout>
</template>

<script>

import StandardLayout from "@/layouts/StandardLayout";

export default {
  components: {StandardLayout},
  props: {},
  data() {
    return {
      reservations: []
    }
  },
  methods: {
    loadReservations() {
      this.$api.get('/reservations')
          .then(response => this.reservations = response.data)
          .catch(error => this.handleError(error))
    },
    getBadgeClass(state) {
      if (state === 'requested')
        return 'badge-warning'
      if (state === 'confirmed')
        return 'badge-success'
      if (state === 'expired' || state === 'canceled')
        return 'badge-danger'
      return ''
    }
  },
  activated() {
    this.loadReservations()
  },
  mounted() {
    this.loadReservations()
  }
}
</script>
